import { videoItems } from "@/mocks/home";

export default function VideoShowcase() {
  return (
    <section id="videos" className="w-full bg-foreground-950">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-8">
          <div>
            <span className="text-accent-400 text-xs font-medium tracking-[0.24em] uppercase">
              Video Archive
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-background-50 mt-2">
              视频资源 · 在线顺畅观赏
            </h2>
            <p className="text-sm md:text-base text-background-50/70 mt-2 max-w-2xl">
              收录高人气视频作品，提供 1080P 与 4K 清晰度，支持倍速播放与多端观赏。
            </p>
          </div>
          <a
            href="#subscribe"
            className="inline-flex items-center gap-1.5 bg-accent-500 hover:bg-accent-600 text-foreground-950 text-sm font-medium h-11 px-6 rounded-full transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-line text-lg" />
            观看全部视频
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
          {videoItems.map((item) => (
            <article
              key={item.id}
              className="group rounded-lg overflow-hidden border border-background-50/10 bg-background-50/[0.04] transition-colors hover:border-accent-500/40 cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.cover}
                  alt={`小蜜桃视频 ${item.title}`}
                  title={`${item.title} - 美丽的小蜜桃视频资源`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-foreground-950/35" />
                <span className="absolute inset-0 flex items-center justify-center">
                  <span className="w-14 h-14 flex items-center justify-center rounded-full bg-background-50/95 text-primary-600 group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-2xl" />
                  </span>
                </span>
                <span className="absolute bottom-3 right-3 text-[11px] font-medium px-2 py-1 rounded bg-foreground-950/75 text-background-50">
                  {item.duration}
                </span>
                <span className="absolute top-3 left-3 text-[11px] font-medium px-2 py-1 rounded bg-accent-500 text-foreground-950">
                  {item.quality}
                </span>
              </div>
              <div className="p-4 md:p-5 flex items-start justify-between gap-3">
                <span className="flex flex-col min-w-0">
                  <h3 className="font-heading font-bold text-base text-background-50 truncate">
                    {item.title}
                  </h3>
                  <span className="text-xs text-background-50/60 mt-1.5 flex items-center gap-3">
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-eye-line" />
                      {item.views}
                    </span>
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-hd-line" />
                      {item.quality} 清晰度
                    </span>
                  </span>
                </span>
                <button
                  type="button"
                  aria-label="收藏视频"
                  className="w-9 h-9 shrink-0 rounded-full bg-background-50/10 text-background-50 hover:bg-accent-500 hover:text-foreground-950 flex items-center justify-center transition-colors cursor-pointer"
                >
                  <i className="ri-bookmark-line" />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}